export const devops = {
  dataDownloadList: '/devops/v1/dataDownloadResource/list',
  delete: '/devops/v1/dataDownloadResource/delete',
  log: '/devops/v1/dataDownloadResource/getLogBySourceId',
  download: '/devops/v1/dataDownloadResource/getFilePath',
  getApprovalStatusOption: '/devops/v1/dataDownloadResource/getApprovalStatusOption'
}
